import React, { useState } from 'react';
import './App.css';
import { Link, useNavigate } from 'react-router-dom';

const curriculumData = {
  reiki: [
    'Introduction to Reiki & Energy Healing',
    'History and Principles of Reiki',
    'Hand Positions & Self-Healing Techniques',
    'Distance Healing Methods',
    'Attunement Ceremony & Practice',
    'Certification Requirements',
  ],
  coaching: [
    'Foundations of Intuitive Coaching',
    'Active Listening & Powerful Questioning',
    'Intuitive Tools & Techniques',
    'Live Practice Sessions',
    'Client Case Studies',
    'Final Assessment & Certification',
  ],
};

const courseInfo = {
  reiki: {
    name: 'Reiki Certification',
    price: '$99',
  },
  coaching: {
    name: 'Intuitive Coaching Certification',
    price: '$149',
  },
};

function Courses() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState([]);
  const [modalTitle, setModalTitle] = useState('');
  const navigate = useNavigate();

  // Helper to check if mobile view
  const isMobile = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 480px)').matches;

  const openModal = (type) => {
    setModalTitle(type === 'reiki' ? 'Reiki Certification Curriculum' : 'Intuitive Coaching Curriculum');
    setModalContent(type === 'reiki' ? curriculumData.reiki : curriculumData.coaching);
    setModalOpen(true);
  };
  const closeModal = () => setModalOpen(false);

  const handleEnroll = (type) => {
    navigate(`/checkout/${type}`);
  };

  return (
    <div className="main-bg">
      {/* Hide hero-section on mobile */}
      {!isMobile && (
        <header className="hero-section">
          <div className="logo-circle">
            {/* Logo removed as requested */}
          </div>
          <h1 className="site-title">Life Force Dynamics</h1>
          <p className="site-tagline">A Sacred Space for Spiritual Growth, Healing, and Personal Transformation</p>
        </header>
      )}
      {/* Courses Content */}
      <div className="courses-section" id="courses">
        <h2>Courses & Programs</h2>
        <p className="courses-intro">Explore our online spiritual courses designed to empower your journey and provide professional certification.</p>
        <div className="courses-list">
          <div className="course-card">
            <h3>Reiki Certification</h3>
            <div className="course-price">{courseInfo.reiki.price}</div>
            <ul>
              <li>Level I, II & Master Certification</li>
              <li>Comprehensive video lessons</li>
              <li>Downloadable manuals & resources</li>
              <li>Personal attunement session</li>
            </ul>
            <div className="course-actions">
              <button onClick={() => openModal('reiki')}>Preview Curriculum</button>
              <button onClick={() => handleEnroll('reiki')}>Enroll Now</button>
            </div>
            <div className="certificate-showcase">
            </div>
          </div>
          <div className="course-card">
            <h3>Intuitive Coaching Certification</h3>
            <div className="course-price">{courseInfo.coaching.price}</div>
            <ul>
              <li>Step-by-step coaching framework</li>
              <li>Live practice sessions</li>
              <li>Downloadable workbooks</li>
              <li>Accredited certificate upon completion</li>
            </ul>
            <div className="course-actions">
              <button onClick={() => openModal('coaching')}>Preview Curriculum</button>
              <button onClick={() => handleEnroll('coaching')}>Enroll Now</button>
            </div>
            <div className="certificate-showcase">
            </div>
          </div>
        </div>
      </div>
      {/* Modal Popup */}
      {modalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>&times;</button>
            <h3>{modalTitle}</h3>
            <ul className="modal-curriculum-list">
              {modalContent.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      )}
      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Life Force Dynamics. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default Courses; 